import { render, staticRenderFns } from "./RemountOnWindowWidth.vue?vue&type=template&id=6da794be&"
import script from "./RemountOnWindowWidth.vue?vue&type=script&lang=js&"
export * from "./RemountOnWindowWidth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports